/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import type { EuiBadgeProps } from '@elastic/eui'
import { EuiBadge, EuiCopy } from '@elastic/eui'

import { messages } from '../messages'
import { stringifyTag } from '../helpers'

import type { Tag } from '../types'

type Props = {
  tag: Tag
  hasCopyButton?: boolean
  color?: EuiBadgeProps['color']
}

const TagBadge = ({ tag, hasCopyButton = true, color }: Props) => {
  const { formatMessage } = useIntl()
  const stringifiedTag = stringifyTag(tag)

  const commonBadgeProps: EuiBadgeProps = {
    color,
    ['aria-label']: stringifiedTag,
  }

  if (hasCopyButton) {
    return (
      <EuiCopy textToCopy={stringifiedTag}>
        {(copy) => (
          <EuiBadge
            {...commonBadgeProps}
            iconType='copy'
            iconSide='right'
            iconOnClick={copy}
            iconOnClickAriaLabel={formatMessage({
              ...messages.copyClipboardTag,
            })}
          >
            {stringifiedTag}
          </EuiBadge>
        )}
      </EuiCopy>
    )
  }

  return <EuiBadge {...commonBadgeProps}>{stringifiedTag}</EuiBadge>
}

export default TagBadge
